module.exports = __webpack_public_path__ + "img/logo2.aea2cf73.png";